var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIjaaz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 531,
    viewBox: "0 0 265 531",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_7667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.066 167.646C221.442 165.211 223.188 163.004 225.241 161.105C227.641 159.365 231.476 159.709 234.459 156.43C237.443 153.151 242.083 156.381 242.166 150.17C242.249 143.959 239.513 145.621 242.663 142.676C245.813 139.73 239.841 134.738 239.841 134.738C239.841 134.738 255.684 127.464 254.113 124.153C252.542 120.842 240.48 128.513 224.921 130.691C224.921 130.691 218.716 127.453 217.112 129.529C215.509 131.604 217 150.16 217 150.16L210.703 161.653L220.066 167.646Z",
    fill: "#FBC0A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.703 157.129L214.14 151.635C214.14 151.635 224.868 157.613 227.803 165.91L222.432 169.562L210.703 157.129Z",
    fill: "#F8E8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.921 130.709C230.649 135.706 234.65 142.186 233.146 143.738C231.643 145.29 224.921 140.395 224.921 140.395L225.676 145.986C225.676 145.986 232.515 149.697 234.806 144.374C237.097 139.052 224.921 130.709 224.921 130.709Z",
    fill: "#F69D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.119 132.86C153.216 137.425 172.98 185.951 172.98 185.951C172.98 185.951 178.619 179.726 178.171 185.951L209.825 153.459C209.825 153.459 224.419 158.413 225.587 171.284C225.587 171.284 186.256 225.366 171.984 226.832C157.711 228.298 144.763 188.134 144.763 188.134L151.119 132.86Z",
    fill: "#3E3533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.119 132.86C153.216 137.425 172.98 185.951 172.98 185.951C172.98 185.951 178.619 179.726 178.171 185.951L209.825 153.459C209.825 153.459 224.419 158.413 225.587 171.284C225.587 171.284 186.256 225.366 171.984 226.832C157.711 228.298 144.763 188.134 144.763 188.134L151.119 132.86Z",
    fill: "url(#paint0_linear_24_7667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.468 73.1036C70.5162 73.0124 72.4705 72.2187 74.0023 70.856C75.6672 68.8205 70.2215 52.1448 70.2215 52.1448C73.2815 49.3682 75.1603 45.524 75.4712 41.4037C75.5491 35.1362 71.395 31.9004 64.9341 32.2978C58.4733 32.6953 49.15 41.2909 49.15 41.2909L53.8868 43.7318C53.8868 43.7318 55.4148 57.9639 57.4341 61.6051C59.4535 65.2464 68.468 73.1036 68.468 73.1036Z",
    fill: "#3E3533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0271 45.3598C57.9229 54.2401 64.1958 76.1682 64.1958 76.1682L69.7759 69.8094L66.9751 42.3979L56.0271 45.3598Z",
    fill: "#3E3533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3892 490.685L81.8812 477.363L97.0638 479.576L96.2582 492.079C95.1199 493.904 93.5189 495.396 91.6179 496.403C89.7169 497.41 87.5834 497.896 85.4338 497.812C84.5045 497.969 83.5503 497.881 82.6649 497.558C81.7796 497.235 80.9934 496.687 80.3838 495.968C79.7742 495.249 79.3619 494.384 79.1875 493.458C79.0131 492.532 79.0827 491.576 79.3892 490.685Z",
    fill: "#302624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.158 482.215L146.667 493.045L149.572 500.099L162.102 496.109L164.835 488.074L165.751 475.59L147.158 482.215Z",
    fill: "#302624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.801 500.617C189.916 498.675 177.566 494.946 168.927 488.106C168.455 487.739 167.909 487.477 167.327 487.338C166.745 487.199 166.14 487.186 165.552 487.301L164.886 487.424C164.413 489.267 163.475 490.957 162.16 492.333C160.846 493.708 159.2 494.723 157.381 495.279C153.084 496.659 146.666 493.061 146.666 493.061L145.504 508.42H194.961C195.585 508.073 196.056 507.505 196.283 506.828C196.283 506.828 198.758 503.09 193.801 500.617Z",
    fill: "#302624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.594 238.107C149.594 238.107 157.228 335.514 157.977 344.364C158.726 353.215 168.068 485.074 168.068 485.074C160.233 487.757 151.79 488.124 143.75 486.132L123.294 353.21L109.827 282.318L105.292 281.058C105.292 281.058 103.75 367.356 103.718 366.918C103.686 366.48 101.777 482.791 101.777 482.791C90.4366 488.516 74.6793 482.327 74.6793 482.327C74.6793 482.327 69.7732 369.485 68.3903 362.893C67.0074 356.3 66.6368 229.718 66.6368 229.718L149.594 238.107Z",
    fill: "#3E3533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.892 264.551C135.192 270.337 97.3804 278.968 66.6365 266.353C66.5908 258.45 66.7063 247.972 66.6821 242.418L150.504 249.704C150.885 254.564 151.363 257.805 151.892 264.551Z",
    fill: "#302624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.833 229.297C146.183 226.915 145.66 225.417 145.66 225.417L71.6555 228.454C71.6555 228.454 71.387 229.966 70.9922 232.549C71.3574 233.057 71.6555 233.438 71.6555 233.438C104.679 246.918 128.594 246.932 146.833 229.297Z",
    fill: "#330E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3666 166.368L68.3393 214.023L61.7442 258.548C61.7442 258.548 120.329 280.815 157.094 256.824L149.543 157.326L55.3666 166.368Z",
    fill: "#3E3533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.351 124.533C148.203 127.839 159.228 134.468 149.543 157.326L146.172 227.705C146.172 227.705 149.932 238.55 147.561 240.863C129.317 258.559 105.38 258.559 72.3188 245.062C71.5413 244.108 70.8814 243.064 70.3532 241.953C69.1422 237.17 73.1808 223.819 73.1808 223.819L54.7033 166.378C54.7033 166.378 36.489 141.587 48.5487 132.597C67.5203 118.443 109.279 111.453 140.351 124.533Z",
    fill: "#3E3533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.093 256.826L152.711 199.092C144.172 209.127 137.436 220.564 132.8 232.897C113.2 222.702 96.2739 208.038 83.3901 190.091L97.8424 228.727C85.3477 214.065 65.6564 174.484 53.1645 159.817L68.3337 214.036L61.7386 258.561C61.7386 258.561 120.329 280.819 157.093 256.826Z",
    fill: "url(#paint1_linear_24_7667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.78 116.004C121.661 115.797 124.557 115.967 127.394 116.509C128.721 117.314 132.037 126.901 132.703 128.413C133.369 129.925 123.842 138.834 123.842 138.834C123.842 138.834 131.704 151.743 131.374 152.798C131.044 153.853 117.102 210.263 117.102 210.263C117.102 210.263 83.2964 159.841 82.6063 157.336C81.9162 154.831 85.8447 141.858 85.8447 141.858C85.8447 141.858 75.834 134.481 75.2244 132.87C74.6149 131.259 73.3447 120.977 75.2244 119.672C77.7874 118.685 80.4269 117.91 83.1165 117.355L118.78 116.004Z",
    fill: "#302624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1164 119.783L102.604 170.07C109.781 188.599 117.708 169.216 117.708 169.216L119.945 116.123C119.448 116.088 118.412 115.956 117.918 115.929L83.1164 119.783Z",
    fill: "#F8E8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.354 133.08C119.427 132.589 119.524 126.098 119.524 126.098L119.94 116.27L119.873 116.123C119.354 116.082 118.39 115.961 117.918 115.935L85.8447 119.487C85.9602 119.869 84.6739 122.543 84.9048 123.292C86.763 128.762 92.7513 136.627 93.9516 136.821C95.3614 137.044 98.949 132.935 99.4296 131.593C100.168 132.256 101.43 134.246 102.166 134.912C102.558 144.469 102.212 157.049 102.058 168.671C107.614 183.008 112.8 196.383 115.034 202.154C115.439 202.691 115.839 203.199 116.256 203.69L117.453 175.28C113.837 161.601 110.219 147.923 106.599 134.246C107.749 132.675 109.234 131.504 110.383 129.93C112.203 131.855 114.707 132.986 117.354 133.08Z",
    fill: "url(#paint2_linear_24_7667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.934 121.339C105.818 123.128 101.388 124.086 96.9 124.159C91.7093 124.301 93.7958 121.264 92.0665 120.802L75.2271 81.9219L105.689 95.6491L105.759 96.9407L109.934 121.339Z",
    fill: "#FBC0A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.575 109.241C98.3313 108.839 95.1734 107.917 92.222 106.513C89.3456 105.206 86.5703 103.688 83.9192 101.969L75.2349 81.9209L105.697 95.6481L105.767 96.9398L107.974 109.829C105.834 109.62 103.694 109.496 101.575 109.241Z",
    fill: "#F69D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.708 169.216L106.865 132.618L111.607 127.293L103.551 122.365L97.3912 128.045L103.124 133.123C102.276 145.418 102.096 157.751 102.587 170.067C109.768 188.595 116.18 205.139 116.18 205.139L117.708 169.216Z",
    fill: "#3FD361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7968 110.946C87.7968 110.946 100.044 122.673 103.183 122.163C106.323 121.653 107.963 109.832 107.963 109.832C107.963 109.832 119.15 113.054 120.517 114.609C121.884 116.164 118.543 131.481 117.066 132.225C113.97 133.788 104.642 123.363 102.942 124.706C101.242 126.049 96.438 134.929 94.851 134.752C93.264 134.574 80.6538 122.131 81.3654 117.566C82.077 113.001 87.7968 110.946 87.7968 110.946Z",
    fill: "#F8E8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2494 61.2195C64.2494 61.2195 53.7311 58.8189 55.1865 71.3807C56.6419 83.9425 65.7397 84.1895 68.4223 84.732C68.4223 84.732 73.4277 107.1 101.022 104.958C128.616 102.815 124.091 81.4505 123.887 67.2829C123.683 53.1153 125.267 28.5127 107.206 26.7001C88.9971 24.8714 62.6624 26.0717 64.2494 61.2195Z",
    fill: "#FBC0A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8013 80.6484C99.0344 83.7239 105.101 85.0784 111.146 84.5206C109.43 89.0507 107.614 92.1737 100.941 91.1104C99.7493 90.9697 98.6013 90.5751 97.5746 89.9531C96.5479 89.3311 95.6665 88.4963 94.9898 87.5048C94.3132 86.5133 93.8569 85.3883 93.6519 84.2055C93.4468 83.0228 93.4978 81.8098 93.8013 80.6484Z",
    fill: "#CB4453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.546 82.7725C93.4477 84.8751 94.1437 86.9379 95.4958 88.5511C96.8479 90.1644 98.7572 91.2102 100.845 91.4809C102.482 91.6949 104.146 91.5361 105.713 91.0163C106.198 89.4803 106.683 87.9443 107.169 86.4084L94.655 82.947C94.2957 82.8359 93.9222 82.7771 93.546 82.7725Z",
    fill: "#F8E8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4321 83.5154C96.0863 85.3633 98.2411 86.6916 100.635 87.3392C102.578 87.8743 104.579 88.1727 106.594 88.2281C106.785 87.6212 106.978 87.0143 107.169 86.4074L96.14 83.3569L94.4321 83.5154Z",
    fill: "#CFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.056 84.6495C108.838 85.3628 108.559 86.0563 108.224 86.7226C103.076 87.4625 97.8388 86.2394 93.5514 83.2961C93.4715 82.4057 93.5562 81.5082 93.8012 80.6484C98.516 83.1243 103.733 84.4927 109.056 84.6495Z",
    fill: "#F8E8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.26 81.032C104.239 80.7635 105.141 80.5245 105.616 79.351C105.894 78.6869 105.955 77.9516 105.788 77.2511C105.549 76.2853 105.197 75.3508 104.741 74.4665C102.816 70.2828 101.634 66.7113 102.104 66.4965C102.574 66.2817 104.521 69.496 106.449 73.6824C106.985 74.7261 107.342 75.8526 107.504 77.0148C107.565 77.5764 107.528 78.1443 107.394 78.6931C107.269 79.1763 107.054 79.6317 106.76 80.0358C106.359 80.6386 105.739 81.0622 105.031 81.2173C104.529 81.2764 104.26 81.1394 104.26 81.032Z",
    fill: "#F69D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2284 58.5928C96.0727 58.8157 95.2912 58.5042 94.0641 58.1766C90.9285 57.2473 87.5548 57.5697 84.6521 59.0761L83.28 59.7636C82.9335 59.9274 82.6972 59.9945 82.6059 59.8978C82.5146 59.8012 82.571 59.5702 82.7805 59.2292C83.0943 58.7536 83.4782 58.3281 83.9191 57.9671C85.3955 56.763 87.1958 56.0236 89.0923 55.8425C90.9889 55.6613 92.8966 56.0465 94.5743 56.9494C95.8283 57.6691 96.3707 58.3968 96.2284 58.5928Z",
    fill: "#3E3533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.892 58.1285C106.715 57.962 107.107 57.1403 108.202 56.2005C109.678 54.9945 111.478 54.2536 113.375 54.0714C115.271 53.8893 117.18 54.2742 118.858 55.1774C119.357 55.449 119.814 55.7928 120.214 56.1978C120.482 56.4958 120.579 56.716 120.512 56.8234C120.445 56.9309 120.198 56.9147 119.827 56.8234L118.347 56.4126C115.216 55.486 111.847 55.8094 108.949 57.3148C107.794 57.8653 107.088 58.3192 106.892 58.1285Z",
    fill: "#3E3533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.019 81.936C91.0849 83.398 90.7159 84.8468 89.9585 86.0991C89.2012 87.3514 88.0895 88.3511 86.7641 88.9717C85.4387 89.5923 83.9589 89.806 82.5121 89.5857C81.0652 89.3655 79.7162 88.7212 78.6355 87.7343C77.5548 86.7474 76.7908 85.4622 76.4404 84.0413C76.09 82.6203 76.1688 81.1274 76.6668 79.7512C77.1647 78.375 78.0596 77.1773 79.2382 76.3096C80.4167 75.4419 81.8261 74.9432 83.2881 74.8764C84.2593 74.832 85.2297 74.9794 86.144 75.3102C87.0582 75.641 87.8983 76.1487 88.6163 76.8044C89.3342 77.46 89.916 78.2506 90.3283 79.1311C90.7405 80.0116 90.9752 80.9647 91.019 81.936Z",
    fill: "url(#paint3_radial_24_7667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.497 80.4093C124.563 81.8714 124.195 83.3204 123.438 84.5731C122.681 85.8257 121.569 86.8258 120.244 87.4468C118.919 88.0678 117.439 88.2818 115.992 88.0619C114.545 87.842 113.195 87.1979 112.114 86.2112C111.033 85.2244 110.269 83.9393 109.919 82.5183C109.568 81.0973 109.647 79.6042 110.144 78.2279C110.642 76.8515 111.537 75.6537 112.716 74.7859C113.894 73.918 115.304 73.4192 116.766 73.3523C118.727 73.2634 120.643 73.9569 122.092 75.2802C123.542 76.6035 124.407 78.4484 124.497 80.4093Z",
    fill: "url(#paint4_radial_24_7667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.717 66.6006C114.75 67.3327 114.566 68.0582 114.186 68.6854C113.807 69.3125 113.251 69.8132 112.587 70.1242C111.924 70.4351 111.183 70.5423 110.458 70.4322C109.734 70.3222 109.058 69.9998 108.517 69.5058C107.976 69.0118 107.593 68.3684 107.417 67.6569C107.242 66.9455 107.281 66.1979 107.53 65.5087C107.779 64.8196 108.227 64.2197 108.817 63.7851C109.407 63.3504 110.113 63.1005 110.845 63.0668C111.827 63.0223 112.786 63.3696 113.512 64.0322C114.238 64.6948 114.672 65.6187 114.717 66.6006Z",
    fill: "#3E3533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7902 66.823C58.226 70.2635 58.84 73.7938 60.533 76.8418C60.8425 77.8277 61.4276 78.7045 62.2193 79.3686C62.4218 79.5224 62.6535 79.6334 62.9001 79.695C63.1468 79.7566 63.4034 79.7676 63.6545 79.7271C63.9055 79.6867 64.1457 79.5958 64.3606 79.4599C64.5755 79.3239 64.7605 79.1458 64.9046 78.9363C65.3369 78.0394 64.7005 77.0297 64.2011 76.1678C63.7016 75.3058 63.4223 74.0195 64.2575 73.4825C64.6468 73.2327 65.157 73.2542 65.5679 73.0367C66.4567 72.5668 66.4513 71.2966 66.2231 70.3138C65.904 68.9556 65.4009 67.6474 64.7274 66.4255C64.0642 65.2279 63.0222 64.0088 61.6554 64.0276C60.2215 64.0464 59.1877 65.4561 58.7902 66.823Z",
    fill: "url(#paint5_linear_24_7667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9473 492.856C91.5507 491.272 89.5926 490.294 87.4876 490.129C85.3826 489.963 83.2958 490.623 81.669 491.969L79.3972 490.686C76.1077 495.621 69.7839 501.526 68.9891 504.424C67.4746 509.918 70.1625 516.312 79.0132 516.312C87.6437 516.312 95.9575 511.035 96.8946 506.749C97.0544 501.85 96.8408 496.946 96.2555 492.08L92.9473 492.856Z",
    fill: "#302624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.294 353.219L122.894 351.103C127.354 366.707 133.581 387.773 134.709 387.829C136.479 387.921 154.183 385.085 154.953 382.754C155.3 381.707 156.785 365.837 158.313 348.538C160.133 372.907 168.082 485.072 168.082 485.072C160.246 487.755 151.803 488.122 143.764 486.13L123.294 353.219Z",
    fill: "url(#paint6_linear_24_7667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6765 482.338V482.088V481.978L74.655 481.54C74.6335 481.044 74.604 480.327 74.5637 479.406C74.5637 479.196 74.5449 478.976 74.5341 478.742C74.5153 478.326 74.4939 477.875 74.4751 477.4L74.4482 476.836C74.4026 475.762 74.3489 474.553 74.2871 473.219L74.2575 472.553C74.2253 471.792 74.1904 470.996 74.1528 470.165V470.122C74.1125 469.242 74.0723 468.318 74.0293 467.362L74.0078 466.903C73.9031 464.545 73.7877 461.978 73.6641 459.244L73.6265 458.439C73.4144 453.764 73.178 448.624 72.9256 443.227L72.9123 442.958C72.8183 440.931 72.7215 438.868 72.6249 436.782V436.575C71.8193 419.303 70.8822 400.38 70.0739 386V385.947C69.8725 382.351 69.6792 379.043 69.4966 376.116C73.1002 378.723 79.2146 382.853 81.6959 382.772C85.3183 382.654 97.5391 372.711 98.2668 368.285C98.8414 364.746 103.004 331.529 104.652 318.339C104.231 341.631 103.764 367.192 103.748 366.943C103.748 366.927 103.747 367.088 103.734 367.41V367.627C103.707 368.954 103.651 372.147 103.573 376.663C103.573 376.932 103.573 377.2 103.573 377.469C103.543 379.118 103.514 380.928 103.482 382.872C103.469 383.518 103.457 384.18 103.447 384.859C103.401 387.571 103.35 390.498 103.299 393.621C103.299 394.01 103.286 394.4 103.28 394.795C102.703 429.08 101.822 482.813 101.822 482.813C99.708 483.857 97.4423 484.56 95.1089 484.897C94.3409 485.015 93.5729 485.105 92.8049 485.165C92.0369 485.222 91.2689 485.249 90.5116 485.251C89.7544 485.254 89.0025 485.233 88.264 485.192C87.5256 485.152 86.8006 485.088 86.0917 485.01C85.3827 484.932 84.69 484.841 84.0213 484.741C83.017 484.583 82.061 484.403 81.1722 484.204C80.5814 484.075 80.0175 483.936 79.4912 483.812C77.8744 483.418 76.282 482.931 74.7221 482.351L74.6765 482.338Z",
    fill: "url(#paint7_linear_24_7667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2493 61.2181C67.2667 63.8419 69.227 67.4734 69.7649 71.4356H72.9443V59.2793C72.9443 59.2793 82.5711 56.6316 78.9191 42.4882C75.2671 28.3447 60.9276 42.3942 60.9276 42.3942L64.2493 61.2181Z",
    fill: "#3E3533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7308 38.9023C88.3146 41.0869 84.4036 42.3768 80.3581 42.6532C76.3125 42.9296 72.2625 42.1836 68.5809 40.484C55.6915 34.6542 55.764 26.0398 55.764 26.0398C62.9494 25.4752 69.6789 22.2968 74.6792 17.1058C82.3296 8.61757 104.612 0.00851965 121.422 11.6681C138.232 23.3276 132.947 40.441 122.878 43.3277C112.808 46.2144 107.107 39.2246 104.558 40.7686C102.01 42.3126 97.9956 43.9748 91.7308 38.9023Z",
    fill: "#3E3533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.655 17.3456C126.543 15.9907 125.306 14.7437 123.96 13.6211C104.301 26.2862 81.2598 32.6837 57.8854 31.967C58.3485 32.6907 58.8646 33.3791 59.4294 34.0266C57.4981 35.0207 55.6492 36.1674 53.9004 37.4558C66.8893 40.6579 80.4807 40.4915 93.3873 36.9723C106.294 33.4531 118.089 26.6976 127.655 17.3456Z",
    fill: "url(#paint8_linear_24_7667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.042 67.9572C96.8621 68.1666 96.1935 67.8632 95.1623 67.5034C94.5663 67.2943 93.9584 67.1213 93.3417 66.9851C92.5947 66.8318 91.8369 66.7357 91.0753 66.6978C90.3134 66.678 89.5512 66.7175 88.7955 66.8159C88.1698 66.9044 87.5502 67.0308 86.94 67.1946C85.9223 67.4631 85.1677 67.7316 85.0307 67.506C84.8938 67.2805 85.2993 66.6655 86.4083 65.9781C87.0429 65.5953 87.7292 65.3059 88.4464 65.1188C90.2166 64.6491 92.0869 64.7192 93.817 65.3202C94.5179 65.5612 95.1807 65.9012 95.7853 66.3299C96.8084 67.0683 97.2005 67.7772 97.042 67.9572Z",
    fill: "#3E3533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.257 247.326L10.2774 252.639L14.6124 311.922L108.136 305.233L103.257 247.326Z",
    fill: "#3FD361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.925 249.892C53.9445 257.966 53.1387 266.668 53.3613 275.088C53.6243 284.992 56.0984 295.987 64.3716 301.44C72.0708 306.512 82.3552 305.092 91.0091 301.92C96.6312 299.846 101.99 297.118 106.974 293.792L107.861 305.1L39.8855 310.791C40.0519 305.966 39.4005 301.148 37.9589 296.541C34.2168 281.806 30.4748 267.068 26.7329 252.327C26.6758 252.098 26.6188 251.87 26.5591 251.641L51.925 249.892Z",
    fill: "#329849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6353 197.943C34.8864 205.368 34.4616 236.07 34.4616 236.07C35.4548 266.532 39.8522 305.073 42.0291 309.495C44.929 315.39 46.7837 318.515 50.699 315.264C54.6143 312.013 57.4935 318.954 60.224 315.669C62.9544 312.384 67.3826 319.768 68.7286 315.182C70.0746 310.596 62.6184 303.838 62.6184 303.838C62.6184 303.838 66.3388 295.569 54.0065 292.649C42.989 290.025 62.1643 252.027 58.7646 230.352C57.509 222.355 60.8761 203.789 60.9157 203.45C61.6411 197.079 35.6353 197.943 35.6353 197.943Z",
    fill: "#FBC0A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4497 280.901L35.1837 288.875C35.1837 288.875 46.9485 290.973 55.609 287.065L55.676 279.598L34.4497 280.901Z",
    fill: "#F8E8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8843 134.621C40.2241 138.858 32.1485 200.316 30.2044 219.773C28.2603 239.23 32.3665 282.631 32.3665 282.631C40.5747 285.541 49.5701 285.306 57.6151 281.971L60.7098 213.865L67.2996 155.482L46.8843 134.621Z",
    fill: "#3E3533"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_7667",
    x: 0.277374,
    y: 0,
    width: 263.945,
    height: 530.312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_7667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_7667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_7667",
    x1: 158.584,
    y1: 182.686,
    x2: 169.327,
    y2: 177.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302624",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#302624",
    stopOpacity: 0.361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#302624",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24_7667",
    x1: 102.739,
    y1: 176.795,
    x2: 109.148,
    y2: 246.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302624",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#302624",
    stopOpacity: 0.361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#302624",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24_7667",
    x1: 106.721,
    y1: 131.555,
    x2: 155.987,
    y2: 153.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#CFD4D8",
    stopOpacity: 0.631
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#CFD4D8",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#CFD4D8",
    stopOpacity: 0.082
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD4D8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_24_7667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4079.38 176.442) rotate(177.421) scale(7.40077 7.40077)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69D7D",
    stopOpacity: 0.702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#F69D7D",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#F69D7D",
    stopOpacity: 0.443
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#F69D7D",
    stopOpacity: 0.149
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69D7D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_24_7667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4137.17 176.977) rotate(177.421) scale(7.40077 7.40071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69D7D",
    stopOpacity: 0.702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#F69D7D",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#F69D7D",
    stopOpacity: 0.443
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#F69D7D",
    stopOpacity: 0.149
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69D7D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_24_7667",
    x1: -4614.34,
    y1: 73.4773,
    x2: -4608.57,
    y2: 72.6776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#F69D7D",
    stopOpacity: 0.929
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#F69D7D",
    stopOpacity: 0.745
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69D7D",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_24_7667",
    x1: -3863.11,
    y1: 345.9,
    x2: -3890.43,
    y2: 492.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302624",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#302624",
    stopOpacity: 0.361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#302624",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_24_7667",
    x1: -3804.89,
    y1: 347.048,
    x2: -3861.61,
    y2: 474.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302624",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#302624",
    stopOpacity: 0.361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#302624",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_24_7667",
    x1: 94.244,
    y1: 44.3374,
    x2: 93.6585,
    y2: 21.5875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E8D8",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#F8E8D8",
    stopOpacity: 0.129
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E8D8",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIjaaz);
export default __webpack_public_path__ + "static/media/ijaaz.7a2c4fa28fefabcb41f7e7ea87e84c05.svg";
export { ForwardRef as ReactComponent };